/**
 * Footer accordion handler for mobile screens.
 */

export function initFooter() {
	const mediaQuery = window.matchMedia('(max-width: 48rem)');

	const initializeFooter = (footer) => {
		const groups = Array.from(footer.querySelectorAll('.cyprus-footer__group'));

		const syncGroups = () => {
			groups.forEach((group) => {
				group.open = !mediaQuery.matches || group.dataset.mobileOpen === 'true';
			});
		};

		syncGroups();
		mediaQuery.addEventListener('change', syncGroups);
	};

	document.querySelectorAll('[data-cyprus-footer]').forEach(initializeFooter);
}

// Auto-initialize when DOM is ready
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initFooter);
} else {
	initFooter();
}
